module.exports = __webpack_public_path__ + "img/feature-3.53761300.png";